module.exports = __webpack_public_path__ + "static/media/Forma 1 copy 10.b051e089.svg";